import IndexLayout from "../Layouts/IndexLayout";
import MainLayout from "../Layouts/MainLayout";
import PagesLayaut from '../Layouts/PagesLayaut'
import { createBrowserRouter } from "react-router-dom";
import Productos from '../Pages/Productos/Productos'
import Usuarios from '../Pages/Usuarios/Usuarios'
import Banners from "./Banners/Banners";
import Main from "./Main/Main";
import Contacto from "./Contacto/Contacto";
import Categorias from "./Categorias/Categorias";
import Codigos from "./Codigos/Codigos";
import Eventos from "./Eventos/Eventos";
import PageDetail from '../Pages/PageDetail/PageDetail';
import VerificarAfiliado from './Afiliado/VerificarAfiliado';
import CentrosPage from './Centros/CentrosPage';
import CentrosServicios from './CentrosServicios/CentrosServicios';
import Configuracion from './Configuracion/Configuracion';
import QuienesSomosPage from './QuienesSomos/QuienesSomosPage';

export const router = createBrowserRouter([

    {
        path: "/",
        element: <IndexLayout />,

    },
    {
        path: "/",
        element: <PagesLayaut />,
        children: [
            {
                path: `/producto/:idProducto/:producto`,
                element: <PageDetail />,
            },
            {
                path: `/verificar-afiliado`,
                element: <VerificarAfiliado />,
            },
            {
                path: `/afiliado`,
                element: <VerificarAfiliado />,
            },
            {
                path: `/centros`,
                element: <CentrosPage />,
            },
            {
                path: `/quienes-somos`,
                element: <QuienesSomosPage />,
            },
            {
                path: `/acerca-de-dxn`,
                element: <QuienesSomosPage />,
            },
            {
                path: `/nosotros`,
                element: <QuienesSomosPage />,
            },
        ]
    },
    {
        path: "/",
        element: <MainLayout />,
        children: [
            {
                path: `/dashboard`,
                element: <Main />,
            },
            {
                path: `/dashboard/productos`,
                element: <Productos />,
            },
            {
                path: `/dashboard/usuarios`,
                element: <Usuarios />,
            },
            {
                path: `/dashboard/banners`,
                element: <Banners />,
            },
            {
                path: `/dashboard/contacto`,
                element: <Contacto />,
            },
            {
                path: `/dashboard/categorias`,
                element: <Categorias />,
            },
            {
                path: `/dashboard/codigos`,
                element: <Codigos />,
            },
            {
                path: `/dashboard/eventos`,
                element: <Eventos />,
            },
            {
                path: `/dashboard/centros-servicios`,
                element: <CentrosServicios />,
            },
            {
                path: `/dashboard/configuracion`,
                element: <Configuracion />,
            },
        ],
    },


]);
